import React from 'react';
const bonuses = [{
  num: '01',
  emoji: '🗣',
  title: 'Bibliothek der Eröffnungen',
  desc: '50 fertige Intros für einen autoritären Start.'
}, {
  num: '02',
  emoji: '📖',
  title: '52 Tiefe Intentionen',
  desc: 'Ein kraftvolles Thema für jede Woche des Jahres.'
}, {
  num: '03',
  emoji: '🌊',
  title: 'Handbuch für fließende Übergänge',
  desc: 'Machen Sie Ihre Flows elegant wie einen Tanz.'
}, {
  num: '04',
  emoji: '✅',
  title: 'Pre-Class Checkliste',
  desc: 'Alles unter Kontrolle in 3 Minuten vor Kursbeginn.'
}, {
  num: '05',
  emoji: '🌙',
  title: '30 Unvergessliche Abschlüsse',
  desc: 'Schlussworte, die im Herzen der Schüler bleiben.'
}, {
  num: '06',
  emoji: '📅',
  title: 'Der Visuelle Planer',
  desc: 'Ihre ganze Woche auf einen Blick geplant.'
}];
export function BonusSection() {
  return <section className="w-full bg-bg-main py-20 px-4" data-id="element-12">
      <div className="max-w-4xl mx-auto" data-id="element-13">
        <div className="text-center mb-14" data-id="element-14">
          <h2 className="text-3xl sm:text-5xl font-black text-text-main mb-3 tracking-tight" data-id="element-15">
            🔥 6 Exklusive Boni
          </h2>
          <p className="text-text-sec text-lg sm:text-xl font-medium mb-2" data-id="element-16">
            (Wert 149 € — HEUTE GRATIS)
          </p>
          <p className="text-badge-red font-black text-xl sm:text-2xl line-through opacity-90 drop-shadow-[0_0_10px_rgba(239,68,68,0.3)]" data-id="element-17">
            Gesamtwert: 149 €
          </p>
        </div>

        <div className="space-y-4" data-id="element-18">
          {bonuses.map((bonus, i) => <div key={i} className="bg-bg-alt/80 backdrop-blur-sm rounded-2xl border border-border-light p-5 sm:p-6 flex flex-col sm:flex-row items-start sm:items-center gap-4 sm:gap-5 transition-all hover:-translate-y-1 hover:border-secondary/30 hover:shadow-[0_10px_30px_rgba(245,158,11,0.1)] group" data-id="element-19">
              <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-secondary/20 to-secondary/5 border border-secondary/20 flex items-center justify-center flex-shrink-0 text-2xl shadow-inner group-hover:from-secondary/30 transition-colors" data-id="element-20">
                {bonus.emoji}
              </div>

              <div className="flex-1 min-w-0" data-id="element-21">
                <h3 className="text-text-main font-bold text-lg sm:text-xl mb-0.5" data-id="element-22">
                  <span className="text-secondary mr-2" data-id="element-23">{bonus.num}.</span>
                  {bonus.title}
                </h3>
                <p className="text-text-sec text-sm sm:text-base leading-relaxed" data-id="element-24">
                  {bonus.desc}
                </p>
              </div>

              <span className="bg-secondary/10 text-secondary border border-secondary/20 px-3 py-1.5 rounded-lg font-black text-sm sm:text-base flex-shrink-0 shadow-[0_0_10px_rgba(245,158,11,0.2)]" data-id="element-25">
                GRATIS
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}